// src/components/Login.js

import React, { useState, useEffect,useContext } from 'react';
import { UserContext } from '../contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { isAdmin } from '../utils/auth';
import styles from '../styles/login.module.css'; // Importando CSS Module
import { login,fetchCurrentUser } from '../services/api';

const Login = () => {
  const {setCurrentUser} = useContext(UserContext)
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    // Añadir clase específica para el fondo del login
    document.body.classList.add(styles.loginBg);
    return () => {
      // Quitar clase cuando se salga de la página
      document.body.classList.remove(styles.loginBg);
    };
  }, []);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await login({ email: email, password });
      const response = await fetchCurrentUser();
      const user = response?.data ?? null;
      setCurrentUser(user)
      if (isAdmin(user)) navigate('/admin');
      else navigate('/perfil');
    } catch (error) {
      console.error('Error al iniciar sesión:', error);
      if (error.response) {
        console.error('Error response data:', error.response.data);
        setError(`⚠️ ${error.response.data.error}`);
      } else {
        setError('⚠️ Error al conectar con el servidor');
      }
    }
  };

  return (
    <div className={styles.loginContainer}>
      {error && (
        <div className={styles.flashError}>
          <span className={styles.icon}>⚠️</span> {/* Icono de alerta */}
          {error}
          <span className={styles.close} onClick={() => setError('')}>
            ×
          </span>
        </div>
      )}
      <img src="/static/logo.png" alt="Logo XIOS" />
      <form onSubmit={handleLogin}>
        <div className={styles.formGroup}>
          <label htmlFor="email">Usuario</label>
          <input
            type="text"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className={styles.formControl}
          />
        </div>
        <div className={styles.formGroup}>
          <label htmlFor="password">Contraseña</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className={styles.formControl}
          />
        </div>
        <button type="submit" className={`${styles.btnPrimary} ${styles.btnActive}`} id="loginButton">
          Entrar
        </button>
      </form>
    </div>
  );
};

export default Login;
